module.exports = __webpack_public_path__ + "static/img/5.92c35ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/5.png
// module id = dTrI
// module chunks = 0